<template lang="pug"></template>

<script>
export default {
    name: 'BotaoDashboardPssc',
    componentOptions: {
        title: 'Dashboard',
        actions: [
            [
                {
                    name: 'Dashboard',
                    iconClass: 'lyra-icon lyra-dashboard',
                    showView: false,
                    action: 'abrir',
                    route: 'DashboardPssc'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'DashboardPssc') {
                this.$router.push({ name: 'DashboardPssc' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
